exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tpopover-container{position:relative}[dir] .ant-popover-inner-content{padding:0px !important}", ""]);

